export enum AccessLevelEnum {
  BRAND = 'brand',
  USER_ACCESS_GROUP = 'userAccessGroup',
  COMPANY = 'company',
}
